/* eslint-disable react/jsx-indent */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import useFormattedDate from '../../hooks/useFormattedDate';

import Button from '../buttons/Button';
import StyledButton from '../buttons/StyledButton';
import Image from '../partials/Image';
import Text from '../typography/Text';
import Title from '../typography/Title';

import styles from '../../../styles/cards/event.module.css';

const propTypes = {
    item: PropTypes.shape({}),
    getUrlFromItem: PropTypes.func,
    className: PropTypes.string,
};

function EventCard({ item = null, getUrlFromItem = null, className = null }) {
    const { locale } = useIntl();
    const {
        title = null,
        description = null,
        startDate = null,
        url = null,
        image = null,
        venues = null,
        published = false,
        inDocWeek = false,
    } = item || {};

    const { date, hour, year } = useFormattedDate(startDate, locale);

    const finalUrl = useMemo(
        () => (getUrlFromItem !== null ? getUrlFromItem(item) : url),
        [url, getUrlFromItem],
    );

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            href={finalUrl}
        >
            <div className={classNames([styles.space, styles.dates])}>
                {startDate !== null ? (
                    <>
                        <Title className={styles.date} size="small">
                            {date}
                        </Title>
                        <Title className={styles.date} size="small">
                            {year}
                        </Title>
                        <Title className={styles.spacer} size="small">
                            —
                        </Title>
                        <Title className={styles.date} size="small">
                            {hour}
                        </Title>
                    </>
                ) : null}
            </div>
            <div className={styles.space}>
                <Image
                    className={styles.image}
                    image={image}
                    withDocWeek={inDocWeek}
                    size="small"
                    filtered
                    filteredHover={finalUrl !== null}
                    rounded
                />
            </div>
            <div className={styles.space}>
                {venues !== null && venues.length > 0
                    ? venues.map((venue) => (
                          <Title
                              key={`venue-${venue?.id}`}
                              className={styles.location}
                              size="small"
                          >
                              {venue?.nameWithCity}
                          </Title>
                      ))
                    : null}
                {title !== null ? (
                    <Title className={styles.title} size="medium">
                        {title}
                    </Title>
                ) : null}
                {title === null ? (
                    <Title className={styles.description} size="small">
                        {description}
                    </Title>
                ) : null}
                <Text className={styles.status}>
                    {published ? (
                        <FormattedMessage defaultMessage="Published" description="Button label" />
                    ) : (
                        <FormattedMessage defaultMessage="In approval" description="Button label" />
                    )}
                </Text>
            </div>
            <div className={styles.space}>
                <StyledButton className={styles.button}>
                    <FormattedMessage defaultMessage="View more" description="Button label" />
                </StyledButton>
            </div>
        </Button>
    );
}

EventCard.propTypes = propTypes;

export default EventCard;
